import type { SettingsPayload } from "../SettingsPayload";

/** 担当 1 件ぶんの上書き。 */
export type PromptOverride = { prompt: string; skip: boolean };

/**
 * 規定の写しの担当（`{id: {instruction, skip}}`）。サーバーの器の一部だけを構造で受ける。
 * 生成タスクのスライスを import しないため、型はここで最小限に宣言する。
 */
export type BaselineAssignments = {
    [id: string]: { instruction?: string; skip?: boolean } | undefined;
};

/**
 * 手元の生成設定を、生成の上書き（`overrides.json`）へ載せる**差分**へ写す。
 *
 * 再生成では本体 PPTX を送らず、サーバーは元タスクの内部用出力から `im.prompts` を読む。
 * したがって手元で直した本文はそのままでは届かない。**本文を運ぶ口は上書きだけである**
 * （`apply_overrides` が読む先は S3 の 1 箇所という約束）。
 *
 * **全置換ではなく差分にする。** 上書きは元タスクから新しいタスクへ引き継がれる器で、そこには
 * コンソールで直した本文が入っている。手元の値で丸ごと置き換えると、アドインには見えていない
 * その調整が黙って消える。規定の写しと違うものだけを載せれば、触っていない担当は引き継がれた
 * ままになる。
 *
 * skip も同じ扱いで運ぶ。内部用 PPTX には完了分の `skip: true` が焼き付いており、手元の値は
 * それを読み込んだ状態から利用者が動かしたものである。
 */
export function toPromptOverrides(
    payload: SettingsPayload,
    baseline: BaselineAssignments
): Record<string, PromptOverride> {
    const out: Record<string, PromptOverride> = {};
    for (const [id, a] of Object.entries(payload.assignments ?? {})) {
        const instruction = a.instruction ?? "";
        const skip = a.skip === true;
        const base = baseline[id];
        const baseInstruction = base?.instruction ?? "";
        const baseSkip = base?.skip === true;
        if (instruction === baseInstruction && skip === baseSkip) continue;
        out[id] = { prompt: instruction, skip };
    }
    return out;
}
